const isPair = (node) => typeof node.ar === 'string' && typeof node.en === 'string';
/**
 * Split a tree of pairs into the per-language resource an i18n library wants.
 *
 * Done once at startup. The tree stays the source of truth; this is only the
 * shape the library reads.
 */
export function splitByLocale(tree, locale) {
    const out = {};
    for (const [key, node] of Object.entries(tree)) {
        out[key] = isPair(node) ? node[locale] : splitByLocale(node, locale);
    }
    return out;
}
//# sourceMappingURL=pairs.js.map